import addNumberToHighLevelDB from './add-number-to-highlevel-db'
import checkAvailableNumbers from './check-available-numbers'
import checkTollFreeVerification from './check-tollfree-verification'
import checkVerification from './check-verification'
import clearTableData from './clear-table-data'
import createNumberPool from './create-number-pool'
import createTollFreeVerification from './create-tollfree-verification'
import deleteCallerID from './delete-caller-id'
import deleteNumber from './delete-number'
import deletePool from './delete-pool'
import editNumberPool from './edit-number-pool'
import editPhoneNumber from './edit-phone-number'
import editVerifiedCallerId from './edit-verified-caller-id'
import fetchAgencyTwilio from './fetch-agency-twilio'
import fetchCallerIDs from './fetch-caller-ids'
import fetchCampaigns from './fetch-campaigns'
import fetchCampaignStatus from './fetch-campaign-status'
import fetchCountryNumbers from './fetch-country-numbers'
import fetchCustomerPayment from "./fetch-customer-payment"
import fetchLocalCallerIDs from './fetch-local-caller-ids'
import fetchLocalNumberPools from './fetch-local-number-pools'
import fetchLocalPhoneNumbers from './fetch-local-phone-numbers'
import fetchLocationTwilio from './fetch-location-twilio'
import fetchNumberPool from './fetch-number-pool'
import { fetchPhoneNumbers, fetchPhoneNumbersFromDBPaginated } from './fetch-phone-numbers'
import fetchPhoneNumbersA2PStatus from "./fetch-phone-numbers-a2p-status"
import fetchPhoneNumbersSID from "./fetch-phone-numbers-sid"
import fetchPhoneNumbersTollFreeStatus from "./fetch-phone-numbers-toll-free-status"
import fetchRegulatoryAddresses from './fetch-regulatory-addresses'
import fetchRegulatoryBundles from './fetch-regulatory-bundle'
import fetchAllBundles from './fetch-all-bundles'
import linkPhoneNumber from './link-phone-number'
import purchaseNumber from './purchase-number'
import purchaseNumberWithStripe from './purchase-number-with-stripe'
import resubmitTollFreeVerification from './resubmit-tollfree-verification'
import setA2PComplianceStatus from './set-a2p-compliance-status'
import verificationCall from './verification-call'
import linkAddressOrBundleSid from './link-address-bundle-sid'

import updateEmailList from './update-email-list'
import getEmailList from './fetch-email-list'
import getSubAccountCountUsingLcPhone from './fetch-sub-account-count-using-lc-phone';


import liftLocationSuspension from './lift-location-suspension'

import fetchShowUKKYCBanner from './fetch-uk-kyc-banner'
import fetchA2PRestriction from './fetch-a2p-restriction'
import fetchLocationOnboardingConfig from './fetch-location-onboarding-config'
import updateOnboardingConfig from './update-onboarding-config'
import liftLocationTwilioSuspension from './lift-location-twilio-suspension'

import getLocationData from './get-location-data'
import putLocationData from './put-location-data'
import putTwilioData from './put-twilio-data'
import fetchNumberPools from './fetch-number-pools'
import addNumberToPool from './add-number-to-pool'
import removeNumberFromPool from './remove-number-from-pool'
import transferNumberBetweenPools from './transfer-number-between-pools'
import deleteNumberFromPool from './delete-number-from-pool'

const actions = {
  addNumberToHighLevelDB,
  checkAvailableNumbers,
  checkTollFreeVerification,
  checkVerification,
  clearTableData,
  createNumberPool,
  createTollFreeVerification,
  deleteCallerID,
  deleteNumber,
  deletePool,
  editNumberPool,
  editPhoneNumber,
  editVerifiedCallerId,
  fetchAgencyTwilio,
  fetchCallerIDs,
  fetchCampaigns,
  fetchCampaignStatus,
  fetchCountryNumbers,
  fetchCustomerPayment,
  fetchLocalCallerIDs,
  fetchLocalNumberPools,
  fetchLocalPhoneNumbers,
  fetchLocationTwilio,
  fetchNumberPool,
  fetchNumberPools,
  addNumberToPool,
  removeNumberFromPool,
  transferNumberBetweenPools,
  deleteNumberFromPool,
  fetchPhoneNumbers,
  fetchPhoneNumbersFromDBPaginated,
  fetchPhoneNumbersA2PStatus,
  fetchPhoneNumbersSID,
  fetchPhoneNumbersTollFreeStatus,
  fetchRegulatoryAddresses,
  fetchRegulatoryBundles,
  linkPhoneNumber,
  purchaseNumber,
  purchaseNumberWithStripe,
  resubmitTollFreeVerification,
  setA2PComplianceStatus,
  verificationCall,
  fetchAllBundles,
  linkAddressOrBundleSid,
  fetchShowUKKYCBanner,
  fetchA2PRestriction,
  fetchLocationOnboardingConfig,
  updateOnboardingConfig,
  updateEmailList,
  getEmailList,
  getSubAccountCountUsingLcPhone,
  liftLocationSuspension,
  fetchShowUKKYCBanner,
  liftLocationTwilioSuspension,
  getLocationData,
  putLocationData,
  putTwilioData
}

export default actions
